export const orgAvatarKeycap = {
	surface:
		"bg-linear-to-b from-white to-[#F0F0F0] font-semibold text-[#121212] dark:from-[#303030] dark:to-[#1E1E1E] dark:text-[#F5F5F5]",
	edge: "pointer-events-none absolute inset-0 rounded-[inherit] shadow-[inset_0_0_0_1px_rgba(0,0,0,0.08)] dark:shadow-[inset_0_1px_0_rgba(255,255,255,0.12),inset_0_0_0_1px_rgba(255,255,255,0.06)]",
	drop: "shadow-[0_1px_2px_rgba(0,0,0,0.08)] dark:shadow-[0_1px_2px_rgba(0,0,0,0.6)]",
};
